// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"aY","header":"aZ","overTitle":"a0","image":"a1","title":"a2","description":"a3","email":"a4","button":"a5"};